let clientDetailsVisible;
const initializedClientPrivacyToggles = new WeakSet();

function clientPrivacyElements(root = document) {
  const toggle = root.querySelector("[data-client-details-toggle]");
  const table = root.querySelector("[data-client-details-container]");
  const label = root.querySelector("#client-details-toggle-label");
  const track = root.querySelector("[data-client-details-track]");
  const knob = root.querySelector("[data-client-details-knob]");
  const control = root.querySelector("#client-details-control");

  if (!toggle || !table || !label || !track || !knob || !control) return null;

  return {toggle, table, label, track, knob, control};
}

function setClientDetailsVisible(visible, root = document) {
  const elements = clientPrivacyElements(root);
  if (!elements) return;

  const {toggle, table, label, track, knob} = elements;

  table.classList.toggle("client-details-hidden", !visible);
  toggle.setAttribute("aria-pressed", visible ? "true" : "false");
  label.textContent = visible ? "Hide client details" : "Show client details";

  track.classList.toggle("justify-start", !visible);
  track.classList.toggle("border-tertiary", !visible);
  track.classList.toggle("justify-end", visible);
  track.classList.toggle("border-cta", visible);
  track.classList.toggle("bg-cta", visible);
  knob.classList.toggle("bg-fade", !visible);
  knob.classList.toggle("bg-white", visible);

  table.querySelectorAll(".client-private-access-code button").forEach((control) => {
    control.disabled = !visible;
  });
}

async function persistClientDetailsVisibility(visible, control) {
  const response = await fetch(control.dataset.clientDetailsUpdateUrl, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": control.dataset.csrfToken
    },
    body: JSON.stringify({client_details_visible: visible})
  });

  // An invalid CSRF token redirects to the client list; fetch follows it as a 200.
  if (!response.ok || response.redirected) throw new Error("Unable to save client details visibility");
}

function bootClientPrivacy(root = document) {
  const elements = clientPrivacyElements(root);
  if (!elements) return;

  if (clientDetailsVisible === undefined) {
    clientDetailsVisible = elements.toggle.getAttribute("aria-pressed") === "true";
  }

  if (!initializedClientPrivacyToggles.has(elements.toggle)) {
    elements.toggle.addEventListener("click", async () => {
      const previousVisible = clientDetailsVisible;
      const visible = !previousVisible;

      // Update immediately, but return to the protected state if persistence fails.
      clientDetailsVisible = visible;
      elements.toggle.disabled = true;
      setClientDetailsVisible(visible, root);

      try {
        await persistClientDetailsVisibility(visible, elements.control);
        setClientDetailsVisible(visible);
      } catch (error) {
        clientDetailsVisible = previousVisible;
        setClientDetailsVisible(previousVisible);
      } finally {
        const currentElements = clientPrivacyElements();
        if (currentElements) currentElements.toggle.disabled = false;
      }
    });
    initializedClientPrivacyToggles.add(elements.toggle);
  }

  setClientDetailsVisible(clientDetailsVisible, root);
}

function syncClientSearchInputFromLocation() {
  const input = document.querySelector("[data-client-search-input]");
  if (!input) return;

  input.value = new URL(window.location.href).searchParams.get("query") || "";
}

function clientListResults(target = document) {
  if (target.matches?.("[data-client-list-results]")) return target;
  return target.querySelector?.("[data-client-list-results]") || null;
}

document.addEventListener("DOMContentLoaded", () => bootClientPrivacy());

document.addEventListener("htmx:load", (event) => {
  const results = event.detail?.elt;
  if (results?.matches?.("[data-client-list-results]")) bootClientPrivacy(results);
});

document.addEventListener("htmx:afterSwap", (event) => {
  const results = event.detail?.target;
  if (!results?.matches?.("[data-client-list-results]")) return;

  const currentResults = clientListResults();
  if (currentResults) bootClientPrivacy(currentResults);
});

// Reapply the persisted preference rather than trusting an HTMX history snapshot.
document.addEventListener("htmx:historyRestore", () => {
  syncClientSearchInputFromLocation();
  const results = clientListResults();
  if (results) bootClientPrivacy(results);
});

window.addEventListener("pageshow", () => {
  syncClientSearchInputFromLocation();
  bootClientPrivacy();
});
